module.exports = __webpack_public_path__ + "img/taskNews.aa8d666f.svg";